import addClientService from '../services/addClient'
import getClientsService from '../services/getClients'


import { LIST_TYPE } from '../constant'


export const getClients = options => async (dispatch) => {
  dispatch({ type: 'GET_CLIENTS' })

  try {
    const items = await getClientsService({
      ...options,
      onlyItems: true,
    })

    return dispatch({
      items,
      type: 'GET_CLIENTS_SUCCESS',
      listType: LIST_TYPE.ORDERS,
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'GET_CLIENTS_ERROR',
    })
  }
}

export const addClient = data => async (dispatch) => {
  dispatch({ type: 'LOAD' })

  try {
    await addClientService(data)

    dispatch({ type: 'UNLOAD' })
    dispatch({
      type: 'SNACK_SUCCESS',
      message: 'Le client a été créé avec succès.',
    })

    return true
  } catch (err) {
    dispatch({ type: 'UNLOAD' })
    dispatch({
      type: 'SNACK_ERROR',
      message: err.message,
    })

    return false
  }
}
